<template>
    <div v-if="isPc">
      <el-row :gutter="20" type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6" align="left" v-for="(item,index) in showNews" :key=index >
          <el-card  class="card-news-height">
            <div class="divimage">
              <el-image
                :src=item.url
                class="sceneimage image-transition-scale2">
              </el-image>
            </div>
            <div style="padding: 14px"  @click="btnNewsDetail(item.id)">
              <el-link type="info" :underline="false" style="color:#333"><strong class="font-18 line-height-2">{{item.title}}</strong></el-link>
              <div>
                <div style="float:left"> <p class="font-14">{{item.time}}</p></div>
                <div style="float:right"> <el-button type="text" ><i class="fa fa-arrow-right" aria-hidden="true" style="color:#333"></i></el-button></div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <!-- 移动端适配 -->
   <div v-else>
    <el-row :gutter="20"  type="flex" justify="center" v-for="i in 3" :key=i>
            <el-col :span="24"  v-for="(item,index) in showNews.slice((i-1)*1,i*1)" :key=index >
              <el-card>
                <div class="divimage">
                  <el-image
                    :src=item.url
                    class="sceneimage image-transition-scale2">
                  </el-image>
                </div>
                <div style="padding: 14px" @click="btnNewsDetail(item.id)">
                  <el-link type="primary" :underline="false" style="color:#333"><strong class="font-18 line-height-2">{{item.title}}</strong></el-link>
                  <div>
                    <div style="float:left"> <p class="font-14">{{item.time}}</p></div>
                    <div style="float:right"> <el-button type="text" ><i class="fa fa-arrow-right" aria-hidden="true" style="color:#333"></i></el-button></div>
                  </div>
                </div>
              </el-card>
            </el-col>
      </el-row>
    </div>
</template>
<script>
import {mapState} from "vuex"
export default {
    name:"HomeNews",
    data(){
        return{
           
       }
    },
    mounted(){
         
    },
    props:{

    },
    methods:{
         btnNewsDetail(id){
           this.$router.push({
            path:'/NewsDetail',
            query:{ id: id}
       })
      }
    },
    computed:{
         ...mapState({newsList: 'newsList',isPc:'isPc'}) ,
         showNews(){
            return this.newsList.slice(0,3); //首页端新闻默认展示3个
         }
    }
}
</script>

<style>

</style>